import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// Initialize the theme class (.dark/.light) on <html> before first paint so every
// route — including the public landing page that isn't wrapped by AppLayout — matches.
import '@/stores/themeStore'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
